import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDaysIcon, TrashIcon } from '@heroicons/react/24/outline';
import StatusBadge from '../../../../components/ui/StatusBadge';
import { sameText } from '../../../../utils/format';

const formatHeaderDate = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
    : null;
};

/** Title bar of a session: its event (when named differently), status, upload date and Delete. */
export default function SessionHeader({ session, onDelete }) {
  const headerDate = formatHeaderDate(session.created_at);
  const showEvent = session.event_id && session.event_title && !sameText(session.event_title, session.title);

  return (
    <div className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="session-detail-head">
          <div className="session-detail-head-main">
            <h1 className="session-detail-title">{session.title || 'Session'}</h1>
            <div className="session-detail-meta-row">
              {showEvent && (
                <Link to={`/events/${session.event_id}`} className="session-detail-event-ref" title={`View event: ${session.event_title}`}>
                  <CalendarDaysIcon />
                  <span>{session.event_title}</span>
                </Link>
              )}
              <StatusBadge status={session.status} />
              {headerDate && <span className="session-detail-meta-text">{headerDate}</span>}
            </div>
          </div>
          <div className="session-detail-actions">
            <button type="button" className="session-btn session-btn-danger" onClick={onDelete}>
              <TrashIcon />
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
